import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { socialProfiles } from "../../../../../redux/social-profiles/action";
import { selectSocialProfilesListItems } from "../../../../../redux/social-profiles/selector";
import Table from "../../../../../common/components/table";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const ManagementSocialProfiles = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectSocialProfilesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', sortable: true, filter: true },
      {
        field: 'SocialProfileTypeId',
        headerName: 'SocialProfile Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.SocialProfileType },
        sortable: true,
        filter: true
      },
      { field: 'SocialProfileUrl', headerName: 'SocialProfile Url' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      name: 'Add Social Profiles',
      callback: () => handleAdd(),
    }
  ];

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }


  const handleDelete = (data: any) => {
    dispatch(socialProfiles.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/delete`,
      entity: 'socialProfiles',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(socialProfiles.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/list`,
        entity: 'socialProfiles',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  const fetchSocialProfiles = () => {
    dispatch(socialProfiles.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/list`,
      entity: 'socialProfiles',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchSocialProfiles()
  }, [pageData])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} 
          additionButtons={additionButtons} headingName="Social Profiles" />
      }
    </>
  );
};

export default ManagementSocialProfiles;


